export default __webpack_public_path__ + "assets/teamTable.8579368b.png";